import request from '@/http/request';
import axios from 'axios';

export function postServiceFaultList(data) {
  return request({
    url: 'v1/ops/service_fault_list',
    method: 'POST',
    data: data,
  });
}

export function getPoList(data) {
  return request({
    url: '/api/v1/ops/get_po_list',
    method: 'post',
    data: data,
  });
}

export function getBillingList(data) {
  return request({
    url: '/api/v1/ops/cost_po_list',
    method: 'post',
    data: data,
  });
}

export function exportPoList() {
  return request({
    url: '/api/v1/ops/export_po_list',
    method: 'post',
  });
}

export function exportExpirationList() {
  return request({
    url: '/api/v1/ops/export_expiration_list',
    method: 'post',
  });
}
export function exportChecklist() {
  return request({
    url: '/api/v1/ops/export_check_list',
    method: 'post',
  });
}

export function expirationInfoList(data) {
  return request({
    url: '/api/v1/ops/expiration_info_list',
    method: 'post',
    data: data,
  });
}

export function exportBillingList() {
  return request({
    url: '/api/v1/ops/export_cost_po_list',
    method: 'post',
  });
}

export function getExpirationCount() {
  return request({
    url: '/api/v1/ops/get_expiration_count',
    method: 'post',
  });
}
export function poExpirationList(data) {
  return request({
    url: '/api/v1/ops/po_expiration_list',
    method: 'post',
    data: data,
  });
}
export function getCheckList(data) {
  return request({
    url: '/api/v1/ops/get_check_list',
    method: 'post',
    data: data,
  });
}
export function getCheckListAll(data) {
  return request({
    url: '/api/v1/ops/get_check_list_all',
    method: 'post',
    data: data,
  });
}
export function poOtherNetworkRush(data) {
  return request({
    url: '/api/v1/ops/poOther_network_rush',
    method: 'post',
    data: data,
  });
}

export function updateCheckStatus(data) {
  return request({
    url: '/api/v1/ops/update_po_check_info',
    method: 'post',
    data: data,
  });
}
export function batchUpdatePoCheckInfo(data) {
  return request({
    url: '/api/v1/ops/batch_update_po_check_info',
    method: 'post',
    data: data,
  });
}

export function getConfirmedBillList(data) {
  return request({
    url: '/api/v1/ops/get_Bill_list',
    method: 'post',
    data: data,
  });
}

export function exportBillList(data) {
  return request({
    url: '/api/v1/ops/export_bill_list',
    method: 'post',
    data: data,
  });
}

export function assetCostConfirmList(data) {
  return request({
    url: '/api/v1/ops/asset_po_cost_confirm/list',
    method: 'get',
    params: data,
  });
}

export function assetConfirmAppendix(params) {
  return request({
    url: '/api/v1/ops/asset_po_cost_confirm_appendix/list',
    method: 'get',
    params: params,
  });
}
export function assetConfirmListAll(params) {
  return request({
    url: '/api/v1/ops/asset_po_cost_confirm/list/all',
    method: 'get',
    params: params,
  });
}

export function assetServiceList(params) {
  return request({
    url: '/api/v1/ops/asset_po_service/list',
    method: 'get',
    params: params,
  });
}

export function assetServiceAll(params) {
  return request({
    url: '/api/v1/ops/asset_po_service/list/all',
    method: 'get',
    params: params,
  });
}

export function assetPoServiceAppendix(params) {
  return request({
    url: '/api/v1/ops/asset_po_service_appendix/list',
    method: 'get',
    params: params,
  });
}

export function resourceBillList(data) {
  return request({
    url: '/api/v1/ops/resource_bill_list',
    method: 'post',
    data: data,
  });
}

export function serviceBillList(data) {
  return request({
    url: '/api/v1/ops/service_bill_list',
    method: 'post',
    data: data,
  });
}

export function networkBillList(data) {
  return request({
    url: '/api/v1/ops/network_bill_list',
    method: 'post',
    data: data,
  });
}

export function assetBillList(data) {
  return request({
    url: '/api/v1/ops/asset_bill_list',
    method: 'post',
    data: data,
  });
}

// 上传资产账单数据
export function uploadAssetBill(data) {
  return request({
    url: '/api/v1/ops/asset_bill_upload',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function serviceRenovationBillList(data) {
  return request({
    url: '/api/v1/ops/service_renovation_bill_list',
    method: 'post',
    data: data,
  });
}

export function getPoListAll(data) {
  return request({
    url: '/api/v1/ops/get_po_list_all',
    method: 'post',
    data: data,
  });
}

export function costPoListAll(data) {
  return request({
    url: '/api/v1/ops/cost_po_list_all',
    method: 'post',
    data: data,
  });
}

export function getExpirationListAll(data) {
  return request({
    url: '/api/v1/ops/po_expiration_list_all',
    method: 'post',
    data: data,
  });
}
